import { FileItem } from '@inno-sdks/files'
import { useGetFileItem } from 'modules/desktop/modules/files-integration/api'
import { useTranslation } from 'react-i18next'

import { useItemModal } from '../../../hooks/useItemModal'

export const VideoPreview = () => {
  const { itemId } = useItemModal()
  const { t } = useTranslation('translation', {
    keyPrefix: 'desktop'
  })

  const { data: item } = useGetFileItem<FileItem>(itemId)

  if (!item?.metaData.presignedUrl) {
    return null
  }

  return (
    <video controls width='100%' height='auto'>
      <source src={item.metaData.presignedUrl} />
      {t('video-not-supported')}
    </video>
  )
}
